'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _rcCalendar = require('rc-calendar');

var _rcCalendar2 = _interopRequireDefault(_rcCalendar);

var _Panel = require('rc-time-picker/lib/Panel');

var _Panel2 = _interopRequireDefault(_Panel);

var _BinaryDatePicker = require('./../BinaryDatePicker');

var _BinaryDatePicker2 = _interopRequireDefault(_BinaryDatePicker);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BinaryCalendar = function (_Component) {
  _inherits(BinaryCalendar, _Component);

  function BinaryCalendar(props) {
    _classCallCheck(this, BinaryCalendar);

    var _this = _possibleConstructorReturn(this, (BinaryCalendar.__proto__ || Object.getPrototypeOf(BinaryCalendar)).call(this, props));

    _this.styles = require('./BinaryCalendar.scss');
    return _this;
  }

  _createClass(BinaryCalendar, [{
    key: 'getFormat',
    value: function getFormat(time) {
      var format = this.props.format;

      return time ? { format: format } : 'MM/DD/YYYY h:mm A [CST]';
    }
  }, {
    key: 'disabledDate',
    value: function disabledDate(current) {
      if (!current) {
        return false;
      }
      var date = (0, _moment2.default)();
      date.hour(0);
      date.minute(0);
      date.second(0);
      return current < date; // can not select days before today
    }
  }, {
    key: 'disabledTime',
    value: function disabledTime(current) {
      if (!current) {
        return false;
      }
      var date = (0, _moment2.default)();
      var hours = [];
      for (var index = 0; index <= date.hour(); index++) {
        hours.push(index);
      }
      return {
        disabledHours: function disabledHours() {
          return hours;
        }
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          id = _props.id,
          handleChange = _props.handleChange,
          showTime = _props.showTime,
          showMinute = _props.showMinute,
          showSeconds = _props.showSeconds,
          selectedDate = _props.selectedDate,
          inline = _props.inline,
          disablePrevious = _props.disablePrevious;

      var timePickerElement = _react2.default.createElement(_Panel2.default, { showMinute: showMinute, showSecond: showSeconds, value: selectedDate !== '' ? selectedDate : (0, _moment2.default)().toDate(), defaultValue: (0, _moment2.default)().toDate() });
      return _react2.default.createElement(
        'div',
        { id: id },
        inline && _react2.default.createElement(_rcCalendar2.default, {
          onSelect: handleChange,
          onChange: handleChange,
          timePicker: showTime ? timePickerElement : null,
          showOk: false,
          value: selectedDate !== '' ? selectedDate : (0, _moment2.default)().toDate(),
          defaultValue: selectedDate !== '' ? selectedDate : (0, _moment2.default)().toDate(),
          formatter: this.getFormat.bind(this, true),
          disabledDate: disablePrevious ? this.disabledDate.bind(this) : '',
          disabledTime: disablePrevious ? this.disabledTime.bind(this) : ''
        }),
        !inline && _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(_BinaryDatePicker2.default, {
            selectedDate: selectedDate,
            onChange: handleChange,
            disablePrevious: disablePrevious
          })
        )
      );
    }
  }]);

  return BinaryCalendar;
}(_react.Component);

BinaryCalendar.propTypes = {
  id: _propTypes2.default.string,
  handleChange: _propTypes2.default.func,
  showTime: _propTypes2.default.bool,
  format: _propTypes2.default.string,
  showMinute: _propTypes2.default.bool,
  showSeconds: _propTypes2.default.bool,
  selectedDate: _propTypes2.default.object,
  inline: _propTypes2.default.bool,
  disablePrevious: _propTypes2.default.bool
};
BinaryCalendar.defaultProps = {
  showTime: true,
  format: 'MM/DD/YYYY h:mm A [CST]',
  showMinute: true,
  showSeconds: true,
  inline: true,
  disablePrevious: false
};
exports.default = BinaryCalendar;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@pgforsta/mozart_ui/lib/components/Binary/BinaryCalendar/BinaryCalendar.js
// module id = 2192
// module chunks = 1